import { AfterViewInit, Component, DestroyRef, Inject, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TypedRoute } from '../../../shared/utils/router.utils';
import { BillingResolve } from '../../../shared/models/routeTyping';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ArivoPaymentMethod, Money } from '../../../shared/models/common';
import { ArivoPaymentService } from '../../../shared/components/arivo-payment-container/arivo-payment.service';
import { ArivoPaymentContainerComponent } from '../../../shared/components/arivo-payment-container/arivo-payment-container.component';
import { CoreDataService } from '../../../core/services/core-data.service';
import { FeatureFlagService } from '../../../core/services/feature-flag.service';
import { ArivoPaymentIframeComponent } from '../../../shared/components/arivo-payment-iframe/arivo-payment-iframe.component';

@Component({
  selector: 'app-billing-account-balance',
  templateUrl: './billing-account-balance.component.html',
  styleUrl: './billing-account-balance.component.scss',
})
export class BillingAccountBalanceComponent implements OnInit, AfterViewInit {
  @ViewChild('paymentContainer') paymentContainer!: ArivoPaymentContainerComponent | ArivoPaymentIframeComponent;
  private destroyRef = inject(DestroyRef);
  paymentMethod: ArivoPaymentMethod | null = null;
  openCosts: Money[] = [];
  creditCardIconClass: string | null = null;
  adyenIframeEnabled: boolean = false;
  autoInitPaymentForm: boolean = false;
  initialized: boolean = false;

  constructor(
    @Inject(ActivatedRoute) private route: TypedRoute<BillingResolve>,
    private router: Router,
    private paymentService: ArivoPaymentService,
    private coreDataService: CoreDataService,
    private featureFlagService: FeatureFlagService,
  ) {}

  ngOnInit(): void {
    this.adyenIframeEnabled = this.featureFlagService.getFeatureFlag('enable_iframe_adyen');

    if (this.adyenIframeEnabled) {
      this.paymentContainer = this.paymentContainer as ArivoPaymentIframeComponent;
    } else {
      this.paymentContainer = this.paymentContainer as ArivoPaymentContainerComponent;
    }

    this.route.data.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      this.openCosts = data.billingApiResponse.open_costs;
      this.paymentMethod = data.billingApiResponse.payment_method;
      this.coreDataService.setPaymentMethodAvailability(!!this.paymentMethod);
      if (this.paymentMethod?.brand) {
        this.creditCardIconClass = this.paymentService.getCreditCardIcon(this.paymentMethod.brand);
      }
    });
    this.paymentService.activePaymentMethod.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((paymentMethod) => {
      if (paymentMethod) {
        this.paymentMethod = paymentMethod;
        if (this.paymentMethod?.brand) {
          this.creditCardIconClass = this.paymentService.getCreditCardIcon(this.paymentMethod.brand);
        }
      }
    });
  }

  ngAfterViewInit() {
    this.route.queryParamMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      const showPaymentFormStatus = params.get('showPaymentForm');
      if (showPaymentFormStatus === 'true') {
        if (this.adyenIframeEnabled && !this.initialized) {
          this.autoInitPaymentForm = true;
        } else {
          this.paymentContainer.setUpComponents();
        }
        this.removeShowPaymentFormParam();
      }
      this.initialized = true;
    });
  }

  removeShowPaymentFormParam(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { showPaymentForm: null },
      queryParamsHandling: 'merge',
    });
  }
}
